// The persona list the profile accepts (backend profile.constants PERSONAS),
// with the labels the toast shows, and the pre-fill rule: where the visitor
// first landed, else the door they signed up through, says what they most
// likely came for. Pure, so it is testable without React.
export const PERSONA_OPTIONS = [
    {
        code: 'ai_workflow_builder',
        label: 'AI workflows and agents',
        hint: 'Claude, ChatGPT, MCP, n8n, agent memory',
    },
    {
        code: 'seo_content_strategist',
        label: 'SEO and content strategy',
        hint: 'Search intent, keywords, content gaps',
    },
    {
        code: 'pkm_obsidian',
        label: 'Notes and knowledge management',
        hint: 'Obsidian, Markdown, personal knowledge base',
    },
    {
        code: 'independent_researcher',
        label: 'Research and analysis',
        hint: 'Papers, interviews, documents, qualitative data',
    },
    { code: 'other', label: 'Something else', hint: null },
]

const PATH_RULES = [
    [
        /^\/(mcp|claude|chatgpt|n8n|agents?|ai-?memory)(\/|$|-)/i,
        'ai_workflow_builder',
    ],
    [/^\/(obsidian|notes|pkm|zettelkasten)(\/|$|-)/i, 'pkm_obsidian'],
    [
        /^\/(seo|google|keywords?|search|content|geo)(\/|$|-)/i,
        'seo_content_strategist',
    ],
    [
        /^\/(research|science|pdf|qualitative|interviews?)(\/|$|-)/i,
        'independent_researcher',
    ],
]

const CHANNEL_RULES = {
    mcp: 'ai_workflow_builder',
    obsidian: 'pkm_obsidian',
    extension: 'seo_content_strategist',
}

// The persona code to pre-select, or null when nothing says anything.
export function suggestPersona({ landingPath, acquisitionChannel } = {}) {
    const path = typeof landingPath === 'string' ? landingPath : ''
    for (const [pattern, persona] of PATH_RULES) {
        if (pattern.test(path)) return persona
    }
    return CHANNEL_RULES[acquisitionChannel] || null
}

// Holds 'picked' once answered. Older builds also wrote 'skipped'; those users
// never answered, so only 'picked' settles the question.
const ANSWERED_KEY_PREFIX = 'personaToast.v1:'
export const ANSWERED_VALUE = 'picked'

export const answeredKeyFor = username => `${ANSWERED_KEY_PREFIX}${username}`
